import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VApp,
    { attrs: { "data-qa": "doctor_service_prices" } },
    [
      !_vm.isMounted
        ? _vm._t("default")
        : [
            _c(
              "div",
              {
                staticClass: "d-flex justify-space-between mb-3",
                attrs: { "data-qa": "doctor_service_prices_header" },
              },
              [
                _vm.headerText
                  ? _c(
                      "h2",
                      {
                        staticClass: "text-h5 mr-4",
                        attrs: {
                          "data-qa": "doctor_service_prices_header_text",
                        },
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.headerText) + "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.lpuList.length > 1
                  ? _c("LpuSelect", {
                      attrs: { "lpu-list": _vm.lpuList },
                      model: {
                        value: _vm.selectedLpuId,
                        callback: function ($$v) {
                          _vm.selectedLpuId = $$v
                        },
                        expression: "selectedLpuId",
                      },
                    })
                  : _vm.firstLpu
                  ? _c(
                      "div",
                      {
                        staticClass: "doctor-service-prices-lpu",
                        class: {
                          "doctor-service-prices-lpu_desktop": !_vm.isMobile,
                        },
                        attrs: { "data-qa": "doctor_service_prices_lpu" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "text-subtitle-1 text--text",
                            attrs: {
                              "data-qa": "doctor_service_prices_lpu_name",
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.transDynamic(
                                    _vm.firstLpu,
                                    `name,${_vm.currentLanguageIso},${_vm.needTranslate}`
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "text-body-2 text-secondary--text",
                            attrs: {
                              "data-qa": "doctor_service_prices_lpu_address",
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.transDynamic(
                                    _vm.firstLpu,
                                    `address,${_vm.currentLanguageIso},${_vm.needTranslate}`
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("SearchCombobox", {
              staticClass: "mb-2",
              attrs: {
                "data-qa": "doctor_services_search",
                "initial-data": _vm.serviceCategoryList,
                placeholder: _vm.$t("Найти услугу", {
                  ns: _vm.$i18next.language,
                }),
              },
              on: {
                "search:default": _vm.handleSearchDefault,
                "search:text": _vm.handleSearchText,
                "search:class": _vm.handleSearchCategory,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mb-2",
                class: {
                  "d-flex justify-space-between align-center":
                    !_vm.isMobile && _vm.isShowOnlineSwitch,
                },
              },
              [
                _vm.isShowOnlineSwitch
                  ? _c("OnlineSwitch", {
                      staticClass: "my-2",
                      attrs: {
                        "is-enabled-online-app": _vm.isEnabledOnlineApp,
                      },
                      on: { "online-switch:change": _vm.handleSwitchChange },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("UpdateInfo", {
                  staticClass: "mb-8",
                  attrs: {
                    status:
                      _vm.selectedFormattedServicePricesData.updateInfo.status,
                    "date-string":
                      _vm.selectedFormattedServicePricesData.updateInfo
                        .dateString,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isVisibleServiceList
              ? [
                  _c("PriceList", {
                    staticClass: "d-flex flex-column",
                    attrs: {
                      "category-list": _vm.searchData.categoryList,
                      "is-show-more-button-visible":
                        _vm.isShowMoreServicePricesButtonVisible,
                      "show-more-button-text":
                        _vm.showMoreServicePricesButtonText,
                    },
                    on: {
                      "click:show-calendar": _vm.handleShowCalendar,
                      "click:hide-calendar": _vm.handleHideCalendar,
                      "click:show-more-services":
                        _vm.handleClickShowMoreServices,
                    },
                  }),
                ]
              : _c("div", { staticClass: "text-center py-16 my-1" }, [
                  _c("img", {
                    staticClass: "d-block mb-2 mx-auto",
                    attrs: {
                      "data-qa": "doctor_services_stub",
                      src: "/static/_v1/pd/pictures/ui-kit/search.svg",
                      width: "150",
                      height: "150",
                      alt: "/",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "text--text text-body-1" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("Услуга не найдена", {
                            ns: _vm.$i18next.language,
                          })
                        ) +
                        "\n      "
                    ),
                  ]),
                ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }